class VariantComplementary extends HTMLElement {
    constructor(){
        super();
        
        this.holder = this.querySelector('.product-single__related');
        this.script = this.querySelector('script');
        this.data = this.script ? JSON.parse(this.script.textContent) : null;
        this.currentVariant = this.dataset.variantId;
        this.currentData;
        if (!this.data) return;
    }

    init() {
        this.currentVariant = this.dataset.variantId;
        this.data.forEach(item => {
            if(item.id == this.currentVariant) {
                this.currentData = item;
            }
        })

        this.destroySlider();
        this.renderElements();
    }

    renderElements() {
        this.holder.innerHTML = '';
        if(this.currentData.metafield_variants.length == 0) {
            this.classList.add('hide');
        } else {
            let completeTheLookHtml = '';
            let showSection = false;
            this.currentData.metafield_variants.forEach(variant => {
                if(variant.available) {
                    showSection = true;
                    completeTheLookHtml += `
                        <div class="grid__item grid-product aos-init aos-animate" data-aos="row-of-1" data-product-handle="${variant.product_handle}" data-product-id="${variant.product_id}">
                            <div class="grid-product__content">
                                {{customLabel}}
                                <div class="grid__item-image-wrapper">
                                    <a href="${variant.url}" class="grid-product__link">
                                        <div class="grid-product__image-mask">
                                            <div class="grid__image-ratio grid__image-ratio--portrait">
                                                <image-element data-aos="image-fade-in" data-aos-offset="150" data-product-handle="${variant.product_handle}" class="aos-init aos-animate">
                                                    <img src="/cdn/shop/${variant.img}" alt=""  width="1080" height="1080.0" loading="lazy" class="grid__image-contain image-style--default image-element" sizes="300px">
                                                </image-element>
                                            </div>
                                            <div class="grid-product__quick-add-wrapper">
                                                <button data-prod-id="${variant.product_id}" data-id="${variant.id}" type="button" class="grid-product__quick-atc-btn">Add To Cart</button> 
                                            </div>
                                        </div>
                                        <div class="grid-product__meta">
                                            <div class="grid-product__title grid-product__title--body">${variant.title}</div>
                                            <div class="grid-product__price-color-wrapper">
                                                <div class="grid-product__price">
                                                    {{price}}
                                                </div>  
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                    `;

                    
                    let onSale = false;
                    if(variant.price < variant.compare_at_price) {
                        onSale = true;

                    }

                    let priceHtml = '';
                    const price = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
                    const compare_at_price = theme.Currency.formatMoney(variant.compare_at_price, theme.settings.moneyFormat);
                    priceHtml += `<span class="base-price" data-price="${variant.price}">${price}</span>`;
                    if(onSale) {
                        priceHtml += `          
                            <span class="visually-hidden">Regular price</span>
                            <span class="grid-product__price--original">${compare_at_price}</span>
                            <span class="visually-hidden">Sale price</span>
                        `;
                    }
                    
                    completeTheLookHtml = completeTheLookHtml.replace(/{{price}}/g, priceHtml);

                    let customLabelHtml = '';
                    if (variant.custom_label != "") {
                        customLabelHtml = `<div class="grid-product__tag grid-product__tag--custom">${variant.custom_label}</div>`;
                    } else if (onSale) {
                        customLabelHtml = `<div class="grid-product__tag grid-product__tag--sale">Sale</div>`;
                    }
                    completeTheLookHtml = completeTheLookHtml.replace(/{{customLabel}}/g, customLabelHtml);
                }

                
                

            });
            this.holder.innerHTML = completeTheLookHtml;

            if(showSection) {
                this.initSlider();
                this.classList.remove('hide');
            } else { 
                this.classList.add('hide');
            }
        }
    }

    destroySlider() {
        const flkty = Flickity.data(this.holder);
        if (flkty) { 
            flkty.destroy();
        }
    }

    initSlider() {
        initCustomSlider(this.holder);
    }

    static get observedAttributes() {
        return ['data-variant-id'];
    }

    attributeChangedCallback() {
        this.init();
    }
}

if (!customElements.get('variant-complementary')){
  customElements.define('variant-complementary', VariantComplementary);
}